import { themed } from '@indeed/ifl-css';

// Cannot use logical properties entirely due to how Popper handles flipping between LTR/RTL
const Arrow = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: ["backgroundColor", "borderColor"],
  shouldForwardProp: prop => prop !== "backgroundColor" && prop !== "borderColor",
  target: "e12rfub60"
} : {
  styleProps: ["backgroundColor", "borderColor"],
  shouldForwardProp: prop => prop !== "backgroundColor" && prop !== "borderColor",
  target: "e12rfub60",
  label: "Arrow"
})(_ref => {
  let {
    backgroundColor,
    borderColor
  } = _ref;
  return [{
    inlineSize: "12px",
    blockSize: "12px",
    "&::after": {
      content: '""',
      position: "absolute",
      zIndex: -1,
      borderColor,
      borderStyle: "solid",
      filter: "brightness(0.9)"
    },
    "&::before": {
      content: '""',
      position: "absolute",
      borderColor: backgroundColor,
      borderStyle: "solid"
    },
    [`[data-placement^="top"] > &`]: {
      bottom: 0,
      "&::before": {
        borderBottomColor: "transparent",
        borderLeftColor: "transparent /* @noflip */",
        borderRightColor: "transparent /* @noflip */",
        bottom: "-7px",
        left: "-2px /* @noflip */",
        borderWidth: "8px 8px 0 /* @noflip */",
        transformOrigin: "center top"
      },
      "&::after": {
        borderBottomColor: "transparent",
        borderLeftColor: "transparent /* @noflip */",
        borderRightColor: "transparent /* @noflip */",
        borderWidth: "9px 9px 0 /* @noflip */",
        top: "11px",
        left: "-3px /* @noflip */"
      }
    },
    [`[data-placement^="bottom"] > &`]: {
      top: 0,
      "&::before": {
        borderTopColor: "transparent",
        borderLeftColor: "transparent /* @noflip */",
        borderRightColor: "transparent /* @noflip */",
        top: `-7px`,
        bottom: `15px`,
        left: "-2px /* @noflip */",
        borderWidth: `0 8px 8px /* @noflip */`
      },
      "&::after": {
        borderTopColor: "transparent",
        borderLeftColor: "transparent /* @noflip */",
        borderRightColor: "transparent /* @noflip */",
        borderWidth: `0 9px 9px /* @noflip */`,
        bottom: `11px`,
        left: "-3px /* @noflip */"
      }
    }
  }, {
    [`[data-placement^= "left"] > & `]: {
      right: "0 /* @noflip */",
      "&::before": {
        borderTopColor: "transparent",
        borderRightColor: "transparent /* @noflip */",
        borderBottomColor: "transparent",
        right: "-8px /* @noflip */",
        borderWidth: "9px 0 9px 9px /* @noflip */",
        transformOrigin: "center left /* @noflip */",
        top: "-3px"
      },
      "&::after": {
        borderTopColor: "transparent",
        borderRightColor: "transparent /* @noflip */",
        borderBottomColor: "transparent",
        borderWidth: "9px 0 9px 9px /* @noflip */",
        left: "12px /* @noflip */",
        top: "-3px"
      }
    },
    [`[data-placement^="right"] > & `]: {
      left: "0 /* @noflip */",
      "&::before": {
        borderTopColor: "transparent",
        borderLeftColor: "transparent /* @noflip */",
        borderBottomColor: "transparent",
        left: "-8px /* @noflip */",
        borderWidth: "9px 9px 9px 0 /* @noflip */",
        transformOrigin: "center left /* @noflip */",
        top: "-3px"
      },
      "&::after": {
        borderTopColor: "transparent",
        borderLeftColor: "transparent /* @noflip */",
        borderBottomColor: "transparent",
        borderWidth: "9px 9px 9px 0 /* @noflip */",
        right: "12px /* @noflip */",
        top: "-3px"
      }
    }
  }];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

export { Arrow };
